import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/auth/authApi';
import authReducer from '../features/auth/authSlice';
import roleReducer from '../features/user/roleSlice'

// --- helpers ---
function saveToLocalStorage(state: any): void {
  try {
    localStorage.setItem('authState', JSON.stringify(state));
  } catch (e) {
    console.warn('Could not save state', e);
  }
}

function loadFromLocalStorage(): any {
  try {
    const serialized = localStorage.getItem('authState');
    if (serialized === null) return undefined;
    return { auth: JSON.parse(serialized) };
  } catch (e) {
    console.warn('Could not load state', e);
    return undefined;
  }
}

// --- store ---
export const store = configureStore({
  reducer: {
    auth: authReducer as any,
    role: roleReducer as any,
    [authApi.reducerPath]: authApi.reducer as any,
  },
  preloadedState: loadFromLocalStorage(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware),
});

// subscribe to save
store.subscribe(() => {
  saveToLocalStorage((store.getState() as any).auth);
});

export default store;
